module.exports = __webpack_public_path__ + "img/Cloud Icon - charcoal.d3477c82.svg";